import api from './api';

export const budgetService = {
  // moduleCode restricts the grid to one entry screen's lines
  // (MOD_1_OPEX / MOD_3_MAKE / MOD_4_MOVE). Omit for the whole budget.
  // Server-side filtered and capped. `data` is still the row array so existing
  // callers keep working; `total` / `hasMore` / `limit` ride alongside so the
  // grid can say how much it is NOT showing.
  getGridData: async (versionId, moduleCode, { filters, limit, offset } = {}) => {
    // api.js automatically attaches the x-db-name header
    const response = await api.get(`/budgets/grid/${versionId}`, {
      params: {
        ...(moduleCode ? { module: moduleCode } : {}),
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
      },
    });
    return response.data;
  },

  getVersions: async () => {
    const response = await api.get('/budgets/versions');
    return response.data;
  },

  // payload: { gl_line_id, financial_period, budget_amount }
  updateCell: async (payload) => {
    const response = await api.put('/budgets/grid/cell', payload);
    return response.data;
  },

  // updates: [ { gl_line_id, financial_period, budget_amount } ]
  // One request for a whole batch of manual-cell edits.
  updateCells: async (updates) => {
    const response = await api.put('/budgets/grid/cells', { updates });
    return response.data;
  },

  // P*Q build for one GL line
  getOpexBuild: async (glLineId) => {
    const response = await api.get(`/budgets/build/${glLineId}`);
    return response.data;
  },

  // changes: [ { item_label, stock_code, financial_period, quantity,
  //              unit_price, price_source, price_id } ]
  saveOpexBuild: async (glLineId, changes) => {
    const response = await api.put(`/budgets/build/${glLineId}`, { changes });
    return response.data;
  },
};
